import React from 'react';
import ResumeInfoGrid from '../components/ResumeInfoGrid';
import ResumeEditorForm from '../components/ResumeEditorForm';

/**
 * 单条 section 视图: 展示态(ResumeInfoGrid) ↔ 编辑态(ResumeEditorForm)。
 * 各 section 模块只需声明配置(section)和数据(data),切换逻辑在此统一处理。
 */
const SingleSectionView = ({
  section,
  data,
  editing,
  options,
  applicantId,
  initialValues,
  formRef,
  certificateFile,
  setCertificateFile,
  worksFile,
  setWorksFile,
  onTrigger,
  onSubmit,
  onCancel,
}) => {
  if (editing) {
    return (
      <ResumeEditorForm
        ref={formRef}
        section={section}
        initialValues={initialValues}
        options={options}
        applicantId={applicantId}
        certificateFile={certificateFile}
        setCertificateFile={setCertificateFile}
        worksFile={worksFile}
        setWorksFile={setWorksFile}
        onTrigger={onTrigger}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    );
  }

  return <ResumeInfoGrid fields={section.fields} data={data} emptyText={section.emptyText} />;
};

export default SingleSectionView;